// frontend/src/askos/StudyStreakCard.js
//
// Real data from GET /tenant/{slug}/askos/streak — computed live from
// distinct active days in StudentActivityEvent.
import React, { useEffect, useState } from 'react';
import { getStreak } from '../api/performanceApi';

const DAY_LABELS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const StudyStreakCard = ({ slug }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        getStreak(slug).then(setData).catch(() => setData(null));
    }, [slug]);

    return (
        <article className="panel streak-card">
            <div>
                <div className="panel-heading inline"><h3>Study Streak 🔥</h3></div>
                <div className="streak-ring"><strong>{data ? data.current : '—'}</strong><span>Days</span></div>
            </div>
            <div className="streak-copy">
                {data ? (
                    <>
                        <strong>{data.current > 0 ? 'Keep going!' : 'Start today!'}</strong>
                        <span>{data.current > 0 ? 'Consistency today. Success tomorrow.' : 'Ask a question or practice a PYQ to start your streak.'}</span>
                        <div className="week-row">
                            {(data.week || []).map((active, i) => (
                                <span key={i} className={active ? '' : 'empty'}>{DAY_LABELS[i]}</span>
                            ))}
                        </div>
                        <small>🏆 Longest Streak: {data.longest} day{data.longest === 1 ? '' : 's'}</small>
                    </>
                ) : (
                    <>
                        <strong>Loading…</strong>
                        <span>Streak tracking is computed from your daily activity.</span>
                    </>
                )}
            </div>
        </article>
    );
};

export default StudyStreakCard;
